import Layout from "@/components/Layout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["What is MSIS?", "MSIS (Management Specialization Inclination Scale) is a psychometric self-assessment that helps management students identify which specialization best fits their natural inclinations across 9 domains."],
  ["How long does the test take?", "Approximately 25 to 75 minutes depending on how many domains you select (3 to 9). Each item has a 20-second timer."],
  ["Can I go back to a previous question?", "No. Once you press 'Next', the response is final. This preserves the validity of the assessment."],
  ["What if my internet disconnects?", "Your responses are saved item by item. You can re-enter the test with the same Test ID and email to resume from where you stopped."],
  ["What happens if I don't respond within 20 seconds?", "The system automatically records your response as 'Neutral / Not Sure' and advances to the next item."],
  ["How do I get my report?", "After submitting the test, a detailed PDF report is auto-generated and emailed to you (and your institution, if applicable)."],
  ["Is one Test ID reusable?", "No. Each Test ID is single-use, locked to one verified email, and expires after completion."],
  ["What payment methods are supported?", "We accept all major payment methods (cards, UPI, netbanking) via Razorpay for INR, and international cards for USD."],
];

export default function FAQ() {
  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">FAQ</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">Frequently asked questions.</h1>
        <Accordion type="single" collapsible className="mt-10 max-w-3xl" data-testid="faq-accordion">
          {FAQS.map(([q, a], i) => (
            <AccordionItem value={`q${i}`} key={i}>
              <AccordionTrigger className="text-left font-display font-semibold text-base">{q}</AccordionTrigger>
              <AccordionContent className="text-sm text-slate2">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </Layout>
  );
}
